import { TextComponentConfig } from '../text/text-component-config.interface';

export interface PaymentSummaryAdditionalContent {
  label?: TextComponentConfig;
  text?: TextComponentConfig;
}
